import useSetUpEmbeddedComments from 'collaboration-sidebar/features/deepCommenting/hooks/useSetUpEmbeddedComments';
export default function EmbeddedCommentSetup() {
  "use memo";

  useSetUpEmbeddedComments();
  return null;
}